module.exports = __webpack_public_path__ + "static/media/newsletter-december-2022-5.da3d569f.jpg";